export interface FaqEntry {
  question: string;
  answer: string;
}

export function Faq({ items }: { items: FaqEntry[] }) {
  return (
    <div>
      {items.map((item) => (
        <details className="faq-item" key={item.question}>
          <summary>{item.question}</summary>
          <p>{item.answer}</p>
        </details>
      ))}
    </div>
  );
}
